import React from "react";
import { Container } from "@mui/material";
import StatsDashboard from "../StatsDashboard";

export default function AnalyticsSection() {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <StatsDashboard />
    </Container>
  );
}
